import React from "react";

export function scorePassword(pw) {
  if (!pw) return { score: 0, label: "", color: "transparent" };
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  // 0=empty, 1-2=weak, 3=fair, 4=good, 5=strong
  if (score <= 2) return { score, label: "Weak", color: "#ef4444" };
  if (score === 3) return { score, label: "Fair", color: "#f59e0b" };
  if (score === 4) return { score, label: "Good", color: "#eab308" };
  return { score, label: "Strong", color: "#10b981" };
}

export default function PasswordStrength({ password }) {
  const { score, label, color } = scorePassword(password);
  const pct = (score / 5) * 100;
  if (!password) return null;
  return (
    <div style={{ marginTop: 6 }}>
      <div style={{ height: 4, background: "rgba(255,255,255,0.08)", borderRadius: 999, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${pct}%`, background: color, transition: "width 0.2s ease" }} />
      </div>
      <div style={{ marginTop: 4, fontSize: 11, color, fontWeight: 500 }}>
        {label}
        {score < 3 && (
          <span style={{ color: "#9ca3af", fontWeight: 400, marginLeft: 8 }}>
            Use 8+ chars with uppercase, number, symbol
          </span>
        )}
      </div>
    </div>
  );
}
